// extracted by css-extract-rspack-plugin
export default {"container":"_6ef1fedd","header":"_97144ba5","weekDaysContainer":"_47cab86e","weekDay":"_7a95615a","arrowWrapper":"_8861a0b0","arrow":"_a65fa43","disabled":"_9263fdaa"};